/**
 * Attempts to extract the error message from the given error.
 *
 * @param error
 */
export function extractMessageFromError(error: unknown): string {
  if (error !== null && error !== undefined) {
    if (error instanceof Error) {
      return error.message
    }

    if (typeof error === 'string') {
      return error
    }

    if (
      typeof error === 'object' &&
      'message' in error &&
      typeof error.message === 'string'
    ) {
      return error.message
    }
  }

  return 'An error occurred.'
}

/**
 * Checks whether the error is a network error.
 *
 * @param error
 */
export function isNetworkError(error: unknown): boolean {
  if (error instanceof TypeError && error.message === 'Failed to fetch') {
    return true
  }

  return Boolean(
    error !== null &&
      typeof error === 'object' &&
      'name' in error &&
      error.name === 'NetworkError',
  )
}
